export default __webpack_public_path__ + "img/18.0f31fe08.jpg";